export default __webpack_public_path__ + "static/media/2023_Dogalogue-Front-Cover-Web2-400x482.3af435a0.jpg";